<router-outlet></router-outlet>
  <div class="proposal-repository">
    <!-- <div>
      <app-header></app-header>
      <app-breadcrumb></app-breadcrumb>
    </div> -->
    <div>
      <app-categorybar (emitValues)="getFilterValues($event)" [isSalesCode]="false"></app-categorybar>
    </div>
    <div>
      <div class="proposal_header">
        <div class="h1">
          Proposal Repository
        </div>
      </div>
      <div class="tab-content"  [@revealAnimation]>
        <div *ngIf="activeTab === 'proposals'" class="active proposalpage tab-pane" id="proposalsCarousel">
          
          <div class="proposalbars">
            <div class="search-bar">
              <button type="submit" class="mt-1 " (click)="searchButton()"><i class="material-symbols-outlined searchicons">search</i></button>
              <input type="search" class="search"  [(ngModel)]="searchText" placeholder="Search..." (keydown)="searchButton()" (keyup)="clearSearch()" [class.searchClose]="searchText==''">
              <button type="submit" class=" mt-1 cancel-icon" (click)="clearSearchText()" *ngIf="searchText!=''"><i class="material-symbols-outlined searchicons">close</i></button>
          


          </div>
          <div class="group_filterdiv">
            <div class="groupbybutton" (click)="GroupBy($event)">
              <span class="material-symbols-outlined filtericon">
                filter_alt
              </span> Group by
            </div>
            <div class="addbybutton" [routerLink]="'Home/Proposal Repository/Add Proposal'">
              <span class="material-symbols-outlined filtericon">
                add_circle
              </span>
              &nbsp;&nbsp;Add Proposal
            </div>

          </div>

        </div>
        <div class="no-group" *ngIf="!showgroup">
          <div class="row mx-0">
            <div class="filter-sidebar col-12 col-xl-2 col-lg-3">



              <div class="accordion">
                <div class="accordion-item" *ngFor="let group of groupByList">
                  <div class="accordion-header" (click)="toggleAccordion(group.name)">
                    {{group.name }}
                    <span class="material-icons">
                      {{ isAccordionOpen(group.name) ? 'expand_less' : 'expand_more' }}
                    </span>
                  </div>
                  <div class="accordion-content"
                    [ngClass]="{ 'expanded': isAccordionOpen(group.name), 'closed': !isAccordionOpen(group.name) }"
                    *ngIf="isAccordionOpen(group.name)">

                    <li class="filter-attribute-item" *ngFor="let keys of group.key">
                      <div class="d-flex align-items-center">
                        <input type="checkbox" id="material-attribute-13"
                          (change)="onChange(group.name,keys.key, $event.target.checked)"
                          class="filter-attribute-checkbox ib-m">
                        <span for="material-attribute-13" class="filter-attribute-label ib-m ml-2">
                          {{keys.key}}
                        </span>
                      </div>
                    </li>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-12 col-xl-10 col-lg-9 pr-0">
              <div  infinite-scroll [infiniteScrollDistance]="distance" 
                [infiniteScrollThrottle]="throttle" [infiniteScrollDisabled]="busyGettingData"
                 (scrolled)="onScroll()">
                 <div class="accordion">
                  <div class="accordion-item">
                    <div class="accordion-header" style="background: linear-gradient(90deg, #016AC5 0%, #42439D 100%);" (click)="toggleAccord(0)">
                      {{"RECENT PROPOSALS"}}
                      <span class="material-icons">
                        {{ accord[0] ? 'expand_less' : 'expand_more' }}
                      </span>
                    </div>
                    <div class="accordion-content"
                      [ngClass]="{ 'expanded': accord[0], 'closed': !accord[0] }"
                      style="max-height: 400px;"
                      *ngIf="accord[0]">
                      <ng-container *ngIf="recentItems">
                        <app-proposal-cards [title]="proposalCardsTitle" [dataItems]="recentItems"
                          (actionId)="actionMethods($event)" class="proposecard "></app-proposal-cards>
                      </ng-container>
                    </div>
                  </div>
  
                
              </div>
              <div  infinite-scroll [infiniteScrollDistance]="distance" 
                [infiniteScrollThrottle]="throttle" [infiniteScrollDisabled]="busyGettingData"
                 (scrolled)="onScroll()">
                 <div class="accordion">
                  <div class="accordion-item">
                    <div class="accordion-header" style="background: linear-gradient(90deg, #016AC5 0%, #42439D 100%);" (click)="toggleAccord(1)">
                      {{"ALL PROPOSALS"}}
                      <span class="material-icons">
                        {{ accord[1] ? 'expand_less' : 'expand_more' }}
                      </span>
                    </div>
                    <div class="accordion-content"
                      [ngClass]="{ 'expanded': accord[1], 'closed': !accord[1] }"
                      style="max-height: 400px;"
                      *ngIf="accord[1]">
                      <ng-container *ngIf="dataItems">
                        <app-proposal-cards [title]="proposalCardsTitle" [dataItems]="dataItems"
                          (actionId)="actionMethods($event)" class="proposecard "></app-proposal-cards>
                      </ng-container>
                    </div>
                  </div>
  
                
              </div>
              
            </div>
          </div>
        </div>
        <div *ngIf="showgroup" class="with-group">
          <div class="group-title">
            {{getGroupName(groupName)}}
          </div>
          <div *ngIf="dataItems.length>0" class="filtercards">
            <mat-accordion>
              <mat-expansion-panel id="remove-mat-expansion-panel-padding"
                *ngFor="let data of dataItems; let isFirst = first" [expanded]="isFirst">
                <mat-expansion-panel-header class="matheader">
                  <mat-panel-title>
                    {{data.key}}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-proposal-cards [dataItems]="data.items" (actionId)="actionMethods($event)"></app-proposal-cards>
              </mat-expansion-panel>
            </mat-accordion>
          </div>

        </div>
      </div>


      <div *ngIf="activeTab === 'templates'" class="active tab-pane propsaltemplatesdiv" id="templatesCarousel">
        <app-proposal-templates></app-proposal-templates>
      </div>


      <div *ngIf="activeTab === 'documents'" class="active documentspage tab-pane" id="documentsCarousel">
        <div class="addbybutton refbutton" (click)="addRefDocButton()">
          <span class="material-symbols-outlined filtericon">
            add_circle
          </span>
          &nbsp;&nbsp;Add Reference Document
        </div>

        <div class="card referencetable" *ngIf="referenceDocuments.length != 0">
          <table class="table custom_table individual-template-docs">
            <thead>
              <tr>
                <th class="tableheader">
                  Document Name
                </th>
                <th class="tableheader">
                  Description
                </th>
                <th class="tableheader">
                  No of Downloads
                </th>
                <th class="tableheader">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let doc of referenceDocuments">
                <td class="tdclass">
                  {{doc.name}}
                </td>
                <td class="tdclass">
                  <div class="description" title="{{doc.description}}">{{doc.description}}</div>
                </td>
                <td class="tdclass">
                  <div><small>{{doc.downloadCount}}</small></div>
                </td>
                <td class="tdclass">
                  <span class="msicon material-symbols-outlined" (click)="downloadTemplate(doc.id,doc.sharepointId)">download</span>
                  <span class="msicon material-symbols-outlined" (click)="DeleteTemplate(doc)"
                    *ngIf="isAuthorizedUser(doc)">delete</span>
                  <span class="msicon material-symbols-outlined" (click)="openEditTemplate(doc)"
                    *ngIf="isAuthorizedUser(doc)">edit</span>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
        <div class="tablePagination custom_table"
          [ngStyle]="{'display': referenceDocuments.length>10 ? 'block' : 'none'}">
          <app-pagination #pagination [collectionSize]="referenceDocuments.length" [pageSize]="10"
            [firstLastButtons]="true" [maxSize]="2"></app-pagination>
        </div>

          <div class="card referencetable" *ngIf="referenceDocuments.length != 0">
            <table class="table custom_table individual-template-docs">
              <thead>
                <tr>
                  <th class="tableheader">
                    Document Name
                  </th>
                  <th class="tableheader">
                    Description
                  </th>
                  <th class="tableheader">
                    No of Downloads
                  </th>
                  <th class="tableheader">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let doc of referenceDocuments">
                  <td class="tdclass">
                    {{doc.name}}
                  </td>
                  <td class="tdclass">
                    <div class="description" title="{{doc.description}}">{{doc.description}}</div>
                  </td>
                  <td class="tdclass">
                    <div><small>{{doc.downloadCount}}</small></div>
                  </td>
                  <td class="tdclass">
                    <span class="msicon material-symbols-outlined" (click)="downloadTemplate(doc.id,doc.sharepointId)">download</span>
                    <span class="msicon material-symbols-outlined" (click)="DeleteTemplate(doc)" *ngIf="isAuthorizedUser(doc)">delete</span>
                    <span class="msicon material-symbols-outlined" (click)="openEditTemplate(doc)" *ngIf="isAuthorizedUser(doc)">edit</span>
                  </td>
                </tr>
              </tbody>
            </table>
           
          </div>
          <div class="tablePagination custom_table" [ngStyle]="{'display': referenceDocuments.length>10 ? 'block' : 'none'}">
            <app-pagination #pagination [collectionSize]="referenceDocuments.length" [pageSize]="10" [firstLastButtons]="true"
              [maxSize]="2"></app-pagination>
          </div>
          
          <div *ngIf="referenceDocuments.length == 0">
            <mat-card>
              <mat-card-content class="no-records">No Records Found</mat-card-content>
            </mat-card>
  
          </div>        </div>
      </div>
    </div>
  </div>
</div>